module.exports = __webpack_public_path__ + "static/service-3-e0fb1097d11a267810c1fa19a7f70446.png";